import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledSelectGenderKarma = {
  Container: styled.div<{ $padding?: string }>`
    max-width: 375px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: ${({ $padding }) => $padding || '16px 24px 0'};
    margin: 0 auto;
  `,
  Title: styled.h1`
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    color: ${Color.INK_DARKEST};

    margin-bottom: 12px;
  `,
  Subtitle: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    color: ${Color.INK_LIGHT};
  `,
  CardsContainer: styled.div`
    width: 100%;
    height: 295px;
    display: flex;
    flex-direction: row;
    gap: 12px;

    margin: 24px 0;
  `,
  TermsNote: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    text-align: center;
    color: ${Color.INK_LIGHT};

    padding: 24px 0;
  `,
}
